import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

const isDesignerPath = (pathname: string) => {
  return pathname.startsWith('/designer/');
};

export const useUnsavedChangesGuard = (isDirty: boolean) => {
  // block navigation outside /designer path
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    if (!isDirty) return false;

    const leavingDesigner =
      isDesignerPath(currentLocation.pathname) &&
      !isDesignerPath(nextLocation.pathname);

    return leavingDesigner;
  });

  useEffect(() => {
    if (blocker.state === 'blocked') {
      const ok = window.confirm(
        'You have unsaved changes. Leave without saving?'
      );

      if (ok) blocker.proceed();
      else blocker.reset();
    }
  }, [blocker]);

  // block tab close, or anything that possibility may caused tab close
  // block refresh
  useEffect(() => {
    if (!isDirty) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty]);
};
